import { Link } from 'react-router-dom';
import { GuidedPageHeader } from '../components/onboarding/GuidedPageHeader';
import { NavIcon, type NavIconName } from '../components/ui/NavIcon';
import { useAuthStore } from '../store/auth';

interface MoreLink {
  to: string;
  label: string;
  icon: NavIconName;
  desc: string;
}

const LINKS: MoreLink[] = [
  {
    to: '/tarjeta',
    label: 'Tarjeta de crédito',
    icon: 'card',
    desc: 'Compras, pagos, meses sin intereses y próximos cortes',
  },
  {
    to: '/gastos-fijos',
    label: 'Movimientos fijos',
    icon: 'calendar',
    desc: 'Cargos, ingresos y apartados que se registran automáticamente',
  },
  {
    to: '/deudas',
    label: 'Deudas y préstamos',
    icon: 'wallet',
    desc: 'Saldo, mensualidad, próximas fechas y progreso',
  },
  {
    to: '/presupuesto',
    label: 'Presupuesto',
    icon: 'filter',
    desc: 'Límite mensual (manual y sugerido) con semáforo',
  },
  {
    to: '/metas',
    label: 'Metas de ahorro',
    icon: 'target',
    desc: 'Avance de tus metas y ahorro sugerido',
  },
  {
    to: '/ajustes',
    label: 'Ajustes',
    icon: 'gear',
    desc: 'Perfil, ingreso base, % de ahorro y categorías',
  },
];

export function MorePage() {
  const role = useAuthStore((state) => state.user?.role);
  const links =
    role === 'admin'
      ? [
          ...LINKS,
          {
            to: '/admin/ia',
            label: 'Administración',
            icon: 'chart' as const,
            desc: 'Actividad de la app, adopción y uso de IA',
          },
        ]
      : LINKS;

  return (
    <div className="reference-page w-full">
      <GuidedPageHeader
        section="more"
        title="Más herramientas"
        description="Abre la herramienta que necesitas para organizar pagos, ahorro y decisiones."
      />
      <div>
        <div className="system-page mx-auto max-w-2xl">
          <ul className="space-y-2.5">
            {links.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  className="tap-target flex items-center gap-3 rounded-[18px] border border-slate-200/80 bg-white px-4 py-3.5 shadow-[0_1px_2px_rgba(15,23,42,.04),0_12px_28px_-18px_rgba(15,23,42,.22)] transition hover:-translate-y-px hover:border-slate-300"
                >
                  <span
                    className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-slate-100 text-slate-700"
                    aria-hidden
                  >
                    <NavIcon name={l.icon} className="h-5 w-5" />
                  </span>
                  <span className="min-w-0">
                    <span className="block text-sm font-medium text-slate-800">{l.label}</span>
                    <span className="block text-xs text-slate-600">{l.desc}</span>
                  </span>
                  <span className="ml-auto text-slate-300" aria-hidden>
                    ›
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
